import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import { 
	withSelect, 
	withDispatch 
} from '@wordpress/data'
import { 
	PanelBody, 
	ToggleControl, 
	SelectControl, 
	TextControl 
} from '@wordpress/components'
import { PostTypeCheck, PostIDSelector } from '~cartzillagb/components'
import { Fragment } from '@wordpress/element'
import { i18n } from 'cartzillagb'

const PagePluginSidebar = props => {
	const { 
		bodyClasses, 
		setBodyClasses, 
		disableContainer, 
		setContainer, 
		hidePageHeader, 
		setHidePageHeader, 
		headerStyle, 
		setHeaderStyle,
		isCustomHeader = false,
		headerStaticContentID,
		setHeaderStaticContentId,
		setIsCustomHeader,
		footerStaticContentId = false,
		setFooterStaticContentId = false,
		isCustomFooter = false,
		setIsCustomFooter
	} = props
	
	return(
		<Fragment>
			<PostTypeCheck name="page">
				<PanelBody title={ __( 'General', i18n ) } initialOpen={ false }>
					<TextControl
						label={ __('Body Classes', i18n) }
						value={ bodyClasses }
						onChange={ bodyClasses => { setBodyClasses( bodyClasses )} }
					/>
					<ToggleControl
						label={ __( 'Disable Container ?', i18n ) }
						checked={ disableContainer }
						onChange={ disableContainer => { setContainer( disableContainer )} }
					/>
					<ToggleControl
						label={ __( 'Hide Page Header', i18n ) }
						checked={ hidePageHeader }
						onChange={ hidePageHeader => { setHidePageHeader( hidePageHeader )} }
					/>
				</PanelBody>
				<PanelBody title={ __( 'Header', i18n ) } initialOpen={ false }>
					<ToggleControl
						label={ __( 'Enable Custom Header', i18n ) }
						checked={ isCustomHeader }
						onChange={ isCustomHeader => { setIsCustomHeader( isCustomHeader ) } }
					/>
					{ isCustomHeader && (
						<PostIDSelector
							onPostSelect={ headerStaticContentID => {
								setHeaderStaticContentId( headerStaticContentID ) 
							} }
							posts={ headerStaticContentID ? [ headerStaticContentID ] : [] }
							onChange={ headerStaticContentIDs => {
								if( headerStaticContentIDs && headerStaticContentIDs.length ) {
									setHeaderStaticContentId( { headerStaticContentID : headerStaticContentIDs[0] } )
								} else {

									setHeaderStaticContentId( 0 )
								}
							} }
							postType="mas_static_content"
							limit="1"
						/>
					) }
					{ !isCustomHeader && (
						<SelectControl
							label={ __( 'Header Style', i18n ) }
							value={ headerStyle }
							options={ [
								{ label: __( 'Default', i18n ), value: '' },
								{ label: __( '1 Level Light', i18n ), value: '1-level-light' },
								{ label: __( '1 Level Dark', i18n ), value: '1-level-dark' },
								{ label: __( '2 Level Light', i18n ), value: '2-level-light' },
								{ label: __( '2 Level Dark', i18n ), value: '2-level-dark' },
								{ label: __( '3 Level Light', i18n ), value: '3-level-light' },
								{ label: __( '3 Level Dark', i18n ), value: '3-level-dark' },
								{ label: __( 'Electronics Store', i18n ), value: 'electronics-store' },
								{ label: __( 'Marketplace', i18n ), value: 'marketplace' },
								{ label: __( 'Grocery', i18n ), value: 'grocery' },
							] }
							onChange={ setHeaderStyle }
						/>
					) }
				</PanelBody>
				<PanelBody title={ __( 'Footer', i18n ) } initialOpen={ false }>
					<ToggleControl
						label={ __( 'Enable Custom Footer', i18n ) }
						checked={ isCustomFooter }
						onChange={ isCustomFooter => { setIsCustomFooter( isCustomFooter ) } }
					/>
					{ isCustomFooter && 
						<PostIDSelector
							onPostSelect={ footerStaticContentId => {
								setFooterStaticContentId( footerStaticContentId ) 
							} }
							posts={ footerStaticContentId ? [ footerStaticContentId ] : [] }
							onChange={ footerStaticContentIds => {
								if( footerStaticContentIds && footerStaticContentIds.length ) {
									setFooterStaticContentId( { footerStaticContentId : footerStaticContentIds[0] } )
								} else {
									setFooterStaticContentId( 0 )
								}
							} }
							postType="mas_static_content"
							limit="1"
						/>
					}
				</PanelBody>
			</PostTypeCheck>
		</Fragment>
	)
}

export default compose(
	withSelect( select => {
		const { getEditedPostAttribute } = select( 'core/editor' )
		const meta = getEditedPostAttribute( 'meta' ) || {}
		const { 
			_bodyClasses, 
			_disableContainer, 
			_hidePageHeader, 
			_headerStyle ,
			_isCustomHeader,
			_headerStaticContentID,
			_footerStaticContentId,
			_isCustomFooter
		} = meta
		return {
			bodyClasses: _bodyClasses,
			disableContainer: _disableContainer,
			hidePageHeader: _hidePageHeader,
			headerStyle: _headerStyle,
			isCustomHeader: _isCustomHeader,
			headerStaticContentID: _headerStaticContentID,
			footerStaticContentId: _footerStaticContentId,
			isCustomFooter: _isCustomFooter
		}
	} ),
	withDispatch( dispatch => ( {
		setBodyClasses( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _bodyClasses: value } } )
		},

		setContainer( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _disableContainer: value } } )
		},

		setHidePageHeader( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _hidePageHeader: value } } )
		},

		setHeaderStyle( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _headerStyle: value } } )
		},

		setIsCustomHeader( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _isCustomHeader: value } } )
		},

		setIsCustomFooter( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _isCustomFooter: value } } )
		},

		setHeaderStaticContentId( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _headerStaticContentID: value } } )
		},

		setFooterStaticContentId( value ) {
			dispatch( 'core/editor' ).editPost( { meta: { _footerStaticContentId: value } } )
		},
	} ) ),
)( PagePluginSidebar )